
<template>
  <div class="align-items-center hidden lg:flex">
    <div class="text-2xl font-bold">
      {{ $route.meta.title }}
    </div>
    <Divider v-if="breadcumbs.length > 0" layout="vertical" class="mr-0" />

    <Breadcrumb v-if="breadcumbs.length > 0" :home="home" :model="breadcumbs">
      <template #item="{ item }">
        <router-link
          :to="getBreadcrumbTo(item)"
          custom
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a
            :href="href"
            @click="navigate"
            class="text-breadcrumb text-base cursor-auto"
            :class="{
              'text-primary cursor-pointer': !isActive || !isExactActive
            }"
            >{{ item.title }}</a
          >
        </router-link>
      </template>
    </Breadcrumb>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from "vue"
import { useRoute } from "vue-router"

import Breadcrumb from "primevue/breadcrumb"
import Divider from "primevue/divider"

export default defineComponent({
  name: "AppBreadcrumb",
  components: { Breadcrumb, Divider },
  setup() {
    const route = useRoute()
    const home = ref({
      routeName: "dashboard",
      to: "/",
      title: "Dashboard"
    })

    const breadcumbs = computed(() => {

      // for coporate employee and patient
      const meta = route.meta.breadcrumbs || []
      const corporateId = route.query.corporate_id
      const corporateName = route.query.corporate_name || ''
      const isFromCorporate =
        corporateId &&
        ['patientNew', 'patientEdit', 'patientDetail'].includes(route.name)
      const isFromPreDmUsers =
        route.name === 'patientAppointments' && route.query.from === 'pre-dm'

      if (isFromPreDmUsers) {
        return [
          { title: 'PreDM Users', routeName: 'preDmUsersList' },
          {
            title: "Patient's Appointments",
            to: {
              name: 'patientAppointments',
              params: route.params,
              query: { from: 'pre-dm' }
            }
          }
        ]
      }

      if (!isFromCorporate) return meta

      // Single override: patient form opened from corporate → show corporate trail
      const currentTitle = meta[meta.length - 1]?.title ?? route.name
      return [
        { title: 'Corporate List', to: { name: 'corporateList' } },
        {
          title: 'Employees List',
          to: {
            name: 'corporateEmployees',
            params: { id: corporateId, name: corporateName }
          }
        },
        {
          title: currentTitle,
          to: {
            name: route.name,
            params: route.params,
            query: { corporate_id: corporateId, corporate_name: corporateName }
          }
        }
      ]
    })

    const getBreadcrumbTo = (item) => item.to ?? { name: item.routeName }

    return { breadcumbs, home, getBreadcrumbTo }
  }
})
</script>
<style scoped>
.p-breadcrumb {
  border: none !important;
  background-color: transparent !important;
}
.text-breadcrumb:hover {
  color: var(--primary-color) !important;
}
</style>
